export default __webpack_public_path__ + "static/media/restock.51391c79.png";